import { FaChevronDown } from 'react-icons/fa';

import type { HandleClickLikeParams } from '../../../types';
import { CloseButton } from '../components/close-button';
import { LikeButtonContents } from '../components/like-button-contents';
import { LikeButtonGroupMessage } from '../components/like-button-group-message';
import { LikeButtonGroupSPHiddenMessage } from '../components/like-button-group-sp-hidden-message';
import { LikeButtonGroupWrapper } from '../components/like-button-group-wrapper';
import { LikeButtonWrapper } from '../components/like-button-wrapper';
import { LikeButton } from '../like-button';

type Props = {
  isBlockCompany?: boolean;
  isOpen?: boolean;
  jobDescription: { id: number; jdHash: string };
  onClickLike?: (params: HandleClickLikeParams) => void;
  onClose?: () => void;
};

export const SendLikeButtonGroup = ({
  isBlockCompany,
  isOpen,
  jobDescription,
  onClickLike,
  onClose,
}: Props) => {
  const openClass = isOpen ? 'open' : undefined;

  return (
    <LikeButtonGroupWrapper className={openClass}>
      <LikeButtonContents>
        <div>
          <LikeButtonGroupMessage>
            この求人が気になったら
            <br />
            「いいかも」を押してみましょう
          </LikeButtonGroupMessage>
          <LikeButtonGroupSPHiddenMessage>
            「いいかも」を押すと企業からいいねやオファーが返ってくることがあります。
          </LikeButtonGroupSPHiddenMessage>
        </div>
        <LikeButtonWrapper className={openClass}>
          <LikeButton
            disabledMessage={
              isBlockCompany
                ? '企業をブロックしているため「いいかも」を送ることができません'
                : ''
            }
            isSent={false}
            jobDescription={jobDescription}
            onClick={onClickLike}
          />
        </LikeButtonWrapper>
      </LikeButtonContents>
      <CloseButton
        aria-label="閉じる"
        className={openClass}
        type="button"
        onClick={onClose}
      >
        <FaChevronDown aria-hidden="true" size="16" />
      </CloseButton>
    </LikeButtonGroupWrapper>
  );
};
